exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error-page-wrapper[data-v-301a1469]{\n    width: 100%;\n    height: calc(100vh - 98px);\n    position: relative;\n}\n.error-page-inner[data-v-301a1469]{\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: rgba(255,255,255,0.95);\n    border-radius: 4px;\n    padding: 20px 30px 30px 30px;\n    width: 100%;\n    max-width: 400px;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.02), 0 4px 10px 0 rgba(0, 0, 0, 0.08);\n}\n.error-page-inner h1[data-v-301a1469]{\n    margin-top: 0;\n    margin-bottom: 0;\n    font-weight: bold;\n}\n.error-page-inner h3[data-v-301a1469]{\n    margin-top: 0;\n    margin-bottom: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-301a1469","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/common/404.vue
// module id = 560
// module chunks = 0